{
  "voluntaryChange": {
    "review": {
      "travelExtras": {
        "title": "Tietoja matkasi lisäpalveluista"
      },
      "confirm": {
        "title": "Vahvista muutokset"
      },
      "passengers": {
        "title": "Matkustajat"
      }
    }
  },
  "modifyYourTrip": {
    "upgrade": {
      "available": {
        "title": "Korota matkustusluokkaasi",
        "detail": "Saat lisää etuja, tilaa ja muita herkkuja.",
        "ctaButtonLabel": "Korotusvaihtoehtosi"
      },
      "unavailableGeneric": {
        "title": "Matkustusluokan korotuksia ei ole tarjolla",
        "detail": "Matkustusluokan korotuksia ei ole tarjolla tälle varaukselle."
      },
      "unavailableNoLogin": {
        "title": "Matkustusluokan korotuksia ei ole juuri nyt tarjolla",
        "detail": "Matkustusluokan korotuksia voi tulla myyntiin {daysBeforeDepartureForMoneyUpgrade} päivää ennen lähtöä. Kirjaudu Finnair Plus -tilillesi, niin näet miten voit liittyä jonotuslistalle."
      },
      "unavailableNotEnoughAvios": {
        "title": "Tarvitset hieman lisää Avioksia matkustusluokan korotukseen",
        "detail": {
          "singular": "Tällä hetkellä matkustusluokan korotukseen voi käyttää vain Avioksia. Maksulliset korotukset voivat tulla myyntiin {daysUntilAvailable} päivän kuluttua, jos paikkoja on jäljellä. Voit myös ostaa lisää Avioksia.",
          "plural": "Tällä hetkellä matkustusluokan korotukseen voi käyttää vain Avioksia. Maksulliset korotukset voivat tulla myyntiin {daysUntilAvailable} päivän kuluttua, jos paikkoja on jäljellä. Voit myös ostaa lisää Avioksia."
        }
      },
      "unavailablePointPaymentNotAllowed": {
        "title": "Matkustusluokan korotuksia ei ole juuri nyt tarjolla",
        "detail": {
          "singular": "Maksulliset korotukset voivat tulla myyntiin {daysUntilAvailable} päivän kuluttua, jos paikkoja on jäljellä.",
          "plural": "Maksulliset korotukset voivat tulla myyntiin {daysUntilAvailable} päivän kuluttua, jos paikkoja on jäljellä."
        }
      },
      "waitlist": {
        "title": "Jonota matkustusluokan korotusta",
        "detail": "Matkustusluokka korotetaan automaattisesti jonotuslistalta sitä mukaa, kun paikkoja tulee tarjolle.",
        "ctaButtonLabel": "Liity jonotuslistalle"
      },
      "pending": {
        "title": "Korota matkustusluokkaasi",
        "detail": "Saat lisää etuja, tilaa ja muita herkkuja.",
        "ctaButtonLabel": "Tarkista korotuksen tilanne"
      },
      "loading": {
        "ctaButtonLabel": "Korotusvaihtoehtosi",
        "loaderText": "Ladataan alkaen-hintaa"
      },
      "priceSection": {
        "dividerText": "tai",
        "perPerson": "/ henkilö"
      },
      "cabinClassesModalButtonLabel": {
        "multipleAvailable": "Matkustusluokkien esittely",
        "onlyBusinessAvailable": "Businessluokan esittely",
        "onlyPremiumEconomyAvailable": "Premium Economyn esittely"
      },
      "upgradePageLinkLabel": "Lue lisää",
      "aviosUpsellLinkLabel": "Katso kuinka monta Aviosta tarvitset",
      "loginPopupButtonLabel": "Kirjaudu sisään Finnair Plus -tilillesi"
    }
  },
  "reaccommodation": {
    "ticketSelection": {
      "originalBounds": {
        "originalDepartureHeader": "Alkuperäinen menolento",
        "originalReturnHeader": "Alkuperäinen paluulento"
      }
    }
  }
}
